(function (module) {
    "use strict";

    module.service('forecastCacheService', [function(this: $TSFixMe) {
        var service = this;

        service.setForecast = function (forecast: $TSFixMe) {
            service.forecast = forecast;
        }

        service.getForecast = function () {
            return service.forecast;
        }


    }]);


})(angular.module('topline.services'));